import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import { T } from '../../../../../../../Translations';
import UsersIcon from '../../../../../../Cutesies/UsersIcon';
import Published from './Published';
import Share from './Share';
import PublishingStore from './Store';

interface Props {
  publishingStore: PublishingStore;
}

function PublishSection({ publishingStore }: Props) {
  switch (publishingStore.state.kind) {
    case 'waiting':
    case 'error':
      return emptyFragment();
    case 'ready':
    case 'publishing':
      const { publishLink, publishing, template } = publishingStore.state;
      return (
        <div className="bg-white border-solid border-1 border-gray-200 rounded max-w-md">
          <div className="m-8">
            <div className="pb-6">
              <UsersIcon />
            </div>
            <h3 className="pb-6 text-xl font-semibold">
              <T
                kind="Publish and share with <text>participants</text>"
                text={(content) => <u>{content}</u>}
              />
            </h3>
            <p className="font-sans text-base">
              <T kind="Publish your collection for participants to access..." />
            </p>
            <Published
              publishLink={publishLink}
              publishedAt={publishing.payload.publishedAt}
              publishingStore={publishingStore}
            />
            {just({})
              .assign('publishedAt', publishing.payload.publishedAt)
              .assign('shareUrl', publishing.payload.shareUrl)
              .map(({ shareUrl }) => (
                <Share
                  shareUrlResource={shareUrl}
                  learningCollectionPublishResource={publishing}
                  template={template}
                />
              ))
              .getOrElse(emptyFragment)}
          </div>
        </div>
      );
  }
}

export default observer(PublishSection);
